import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TAppSliceState = {
  isUploadLoading: boolean;
  cardholder: string;
  cardholderMissing: boolean;
  currentNotificationUrl: string;
};

const initialState: TAppSliceState = {
  isUploadLoading: false,
  cardholder: '',
  cardholderMissing: false,
  currentNotificationUrl: '',
};

const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setIsUploadLoading(state, action: PayloadAction<boolean>) {
      // eslint-disable-next-line no-param-reassign
      state.isUploadLoading = action.payload;
    },
    setCardholder(state, action: PayloadAction<string>) {
      // eslint-disable-next-line no-param-reassign
      state.cardholder = action.payload;
    },
    setCardholderMissing(state, action: PayloadAction<boolean>) {
      // eslint-disable-next-line no-param-reassign
      state.cardholderMissing = action.payload;
    },
    setCurrentNotificationUrl(state, action: PayloadAction<string>) {
      // eslint-disable-next-line no-param-reassign
      state.currentNotificationUrl = action.payload;
    },
  },
});

export default appSlice;
